import styled from 'styled-components'
import { COLORS } from 'utils'

import { IconStyles } from '../types'

export const ClearInputCustom = styled.div<IconStyles>`
  margin-top: ${({ marginTop }) => marginTop || '0'};
  margin-bottom: ${({ marginBottom }) => marginBottom || '0'};
  margin-left: ${({ marginLeft }) => marginLeft || '0'};
  margin-right: ${({ marginRight }) => marginRight || '0'};
  cursor: ${({ cursor }) => cursor || 'pointer'};
  /* path {
    fill: ${({ colorIcon }) => colorIcon || COLORS.black};
  } */
  position: realtive;

  &:hover svg {
    background-color: rgba(0, 0, 0, 0.04);
  }

  &:after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.18);
    border-radius: 50%;
    transform: scale(0);
    pointer-events: none;
    transition: transform 0.4s ease;
  }

  // Efeito ao clicar
  &:active {
    &:after {
      transform: scale(1);
      background-color: rgba(0, 0, 0, 0.1);
    }
  }

  svg {
    // Classe do MUI
    display: flex;
    width: 1em;
    height: 1em;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-flex-shrink: 0;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    -webkit-transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    font-size: 1.25rem;
    border-radius: 50%;

    padding: 10px;
    /* stroke: rgb(117 117 117); */

    path {
      fill: rgba(0, 0, 0, 0.54);
    }
  }
`
